import Vue from 'vue'
import App from './App.vue'
import "@devexpress/analytics-core/dist/css/dx-analytics.common.css";
import "devexpress-reporting/dist/css/dx-webdocumentviewer.css";
const params = new URL(window.location.href).searchParams
const darkMode = params.get("darkMode");
const mode = params.get("mode");
if (darkMode === "true") {
  import ("devextreme/dist/css/dx.dark.css");
  import ("@devexpress/analytics-core/dist/css/dx-analytics.dark.css");
} else {
  import ("devextreme/dist/css/dx.light.css");
  import ("@devexpress/analytics-core/dist/css/dx-analytics.light.css");
}
if (mode === "design") {
  import ("ace-builds/css/ace.css");
  import ("ace-builds/css/theme/dreamweaver.css");
  import ("ace-builds/css/theme/ambiance.css");
  import ("@devexpress/analytics-core/dist/css/dx-querybuilder.css");
  import ("devexpress-reporting/dist/css/dx-reportdesigner.css");
}
import router from './router'
Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
